import React from 'react';
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';

function GreetingModal({ shopConfig }) {
  const [cookies, setCookie] = useCookies(['olderThan20']);
  const handleClick = () => {
    setCookie('olderThan20', true, {
      path: '/',
      maxAge: 60 * 60 * 24 * 90, // Expires after 90 days
    });
  };

  return (
    <Modal
      isOpen={!cookies.olderThan20 && shopConfig.isSellingAlcohol}
      centered
      fade={false}
    >
      <ModalBody className="modal-background px-4">
        <Row className="my-3">
          <Col sm={12}>
            <h1>Är du 20 år eller äldre?</h1>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p className="lead">
              Sidan innehåller bla information om alkoholhaltiga drycker och
              vänder sig till företag. För inköp och besök måste du vara 20 år
              eller äldre.
            </p>
            <p>
              Genom att bekräfta din ålder godkänner du även användandet av
              cookies på flaivy.com
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col sm="auto">
            <Button
              id="iAmOldButton"
              color="primary"
              className="my-4"
              onClick={handleClick}
              block
            >
              Jag är över 20 år
            </Button>
          </Col>
          <Col sm="auto">
            <Button color="secondary" className="my-4" block>
              <a href="https://google.com" className="no-style-link">
                Jag är under 20 år
              </a>
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
}

GreetingModal.propTypes = {
  shopConfig: PropTypes.object.isRequired,
};

const mapStateToProps = ({ shopConfig }) => ({
  shopConfig,
});

export default connect(mapStateToProps)(GreetingModal);
